import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useRequestPasswordResetForCurrentUser } from '@/hooks/useChangePassword';
import { useUser } from '@/hooks/useUser';
import { Mail } from 'lucide-react';

interface ChangePasswordDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ChangePasswordDialog({
  open,
  onOpenChange,
}: ChangePasswordDialogProps) {
  const { requestPasswordReset, isLoading } =
    useRequestPasswordResetForCurrentUser();
  const { data: user } = useUser();

  const handleRequestReset = async () => {
    try {
      await requestPasswordReset();
      onOpenChange(false);
    } catch {
      // Error is already handled by the hook's onError
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Changer le mot de passe</DialogTitle>
          <DialogDescription>
            Un lien de réinitialisation sera envoyé à votre adresse email{' '}
            <strong>{user?.email}</strong>. Cliquez sur le lien dans l'email
            pour définir un nouveau mot de passe.
            <br />
            <br />
            <strong>Note :</strong> Vous serez déconnecté après l'envoi de
            l'email pour des raisons de sécurité.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
          >
            Annuler
          </Button>
          <Button
            onClick={handleRequestReset}
            disabled={isLoading}
            className="gap-2"
          >
            {isLoading ? (
              'Envoi en cours...'
            ) : (
              <>
                <Mail className="h-4 w-4" />
                Envoyer le lien par email
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

